<script>
import { UnleashClient } from 'unleash-proxy-client';

export default {
  data() {
    return {
      maintenanceEnabled: false,
      cmsBannerEnabled: false,
      maintenanceMsg: '',
      supportedBrowserBannerEnabled: false,
      isMigrationB2BEnabled: false,
    };
  },
  methods: {
    async initializeUnleash() {
      const unleashConfig = {
        appName: 'forgerock-platform-ui',
        url: process.env.VUE_APP_FEATURE_FLAGS_URL,
        clientKey: process.env.VUE_APP_FEATURE_FLAGS_CLIENT_KEY,
        metricsInterval: parseInt(process.env.VUE_APP_FEATURE_FLAGS_METRIC_INTERVAL),
        refreshInterval: parseInt(process.env.VUE_APP_FEATURE_FLAGS_REFRESH_INTERVAL),
      };

      const unleash = new UnleashClient(unleashConfig);

      unleash.on('error', console.error);
      unleash.on('update', () => {
        this.maintenanceEnabled = unleash.isEnabled(`forgerock.platformUI.maintenance.${process.env.VUE_APP_REALM}.enabled`);
        this.maintenanceMsg = unleash.getVariant(`forgerock.platformUI.maintenance.${process.env.VUE_APP_REALM}.enabled`);
        this.cmsBannerEnabled = unleash.isEnabled('forgerock.platformUI.cmsBanner.enabled');
        this.supportedBrowserBannerEnabled = unleash.isEnabled('forgerock.platformUI.supportedBrowserBanner.enabled');
        this.isMigrationB2BEnabled = unleash.isEnabled('forgerock.platformUI.migrationB2B.enabled');
      });

      await unleash.start();
    },
  },
  created() {
    this.initializeUnleash();
  },
};
</script>
